// ui-library
import { color } from '@upstox/upstox-ui';

export const discrepancyIcon: CSSFunction = ({ theme }) => ({
  padding: 4,
  borderRadius: '50%',
  backgroundColor: color(theme, 'background.default'),
});
